export default __webpack_public_path__ + "static/alexp-5782f5eb320294df2036b75db483d299.png";